/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import Routes from './routes'
import Providers from './providers'

const App = () => {
  return (
    <Providers>
      <Routes />
    </Providers>
  )
}

export default App
